import React from 'react';
import { Spinner } from 'ui-components/src/components/atoms/Spinner';
import { Container } from './styles';

export const LoadingView = () => (
  <Container>
    <Spinner />
  </Container>
);
